import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation files
import en from './translations/en.json';
import es from './translations/es.json';
import fr from './translations/fr.json';
import de from './translations/de.json';
import it from './translations/it.json';
import pt from './translations/pt.json';
import ja from './translations/ja.json';
import zh from './translations/zh.json';
import ru from './translations/ru.json';
import hi from './translations/hi.json';
import el from './translations/el.json';
import sv from './translations/sv.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  pt: { translation: pt },
  ja: { translation: ja },
  zh: { translation: zh },
  ru: { translation: ru },
  hi: { translation: hi },
  el: { translation: el },
  sv: { translation: sv }
};

// Detect initial language: localStorage > browser language > default (en)
const getInitialLanguage = () => {
  // First check localStorage for saved preference
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage) {
    return savedLanguage;
  }
  
  // Then check browser language
  const browserLanguage = navigator.language || navigator.userLanguage;
  if (browserLanguage && browserLanguage.startsWith('es')) {
    return 'es';
  }
  
  // Default to English
  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(), // detect language from localStorage or browser
    fallbackLng: 'en',
    returnEmptyString: false, // Don't return empty strings
    returnNull: false, // Don't return null
    returnObjects: true, // Allow returning objects and arrays for complex structures like journal questions
    interpolation: {
      escapeValue: false // react already escapes
    }
  });

export default i18n;